<div class="d-flex flex-column w-100">
    <span class="h4 w-100" style="text-align: center;">Previsioni di oggi</span>
    <div class="row justify-content-around" style="margin-top: 15px;">
        <div class="col-md-4 d-flex flex-column justify-content-center" style="float: left;">
            <span class="h5 d-flex justify-content-center">Mattina</span>
            <canvas id="canvas" #canvasElem>
                Spiacenti, immagine non disponibile
            </canvas>
        </div>
        <div class="col-md-4 d-flex flex-column justify-content-center" style="float: left;">
            <span class="h5 d-flex justify-content-center">Pomeriggio</span>
            <canvas id="canvasPome" #canvasElemPome>
                Spiacenti, immagine non disponibile
            </canvas>
        </div>
        <div class="col-md-4 d-flex flex-column justify-content-center" style="float: left;">
            <span class="h5 d-flex justify-content-center">Sera/notte</span>
            <canvas id="canvasSera" #canvasElemSera>
                Spiacenti, immagine non disponibile
            </canvas>
        </div>
    </div>
</div>

<!-- <ngb-tab>
    <ng-template ngbTabTitle>
      Domani
    </ng-template>
      <ng-template ngbTabContent>
          <div class="row" style="margin-top: 30px;">
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Mattina</span>
                  <canvas id="canvasDomani" #canvasElemDomani>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Pomeriggio</span>
                  <canvas id="canvasDomaniPome" #canvasElemDomaniPome>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Sera/notte</span>
                  <canvas id="canvasDomaniSera" #canvasElemDomaniSera>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
          </div>
      </ng-template>
  </ngb-tab>
  <ngb-tab>
    <ng-template ngbTabTitle>
        Dopodomani
    </ng-template>
      <ng-template ngbTabContent>
          <div class="row" style="margin-top: 30px;">
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Mattina</span>
                  <canvas id="canvasDopodomani" #canvasElemDopodomani>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Pomeriggio</span>
                  <canvas id="canvasDopodomaniPome" #canvasElemDopodomaniPome>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
              <div class="col-md-4" style="float: left;">
                  <span class="h5">Sera/notte</span>
                  <canvas id="canvasDopodomaniSera" #canvasElemDopodomaniSera>
                      Spiacenti, immagine non disponibile
                  </canvas>
              </div>
          </div>
      </ng-template>
  </ngb-tab> -->
